/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import { Link } from "react-router-dom";
import "jspdf-autotable";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SchoolContext from "../../../Context/SchoolContext";
import ajaxBank from "../../../util/remote/ajaxBank";
import ajaxStudent from "../../../util/remote/ajaxStudent";
import AppContainer from "../../../Components/Structure/AppContainer";
import Loader from "../../../Components/Common/Loader";
import TableHeader from "../../../Components/Common/TableHeader";
import Pagination from "../../../Components/Common/Pagination";
import * as XLSX from "xlsx";
import ajaxStudentGroup from "../../../util/remote/ajaxStudentGroup";
import Select from "react-select";
import PrintFilterFormPM from "../../../Components/Statistics/PocketMoneyBalances/PrintFilterFormPM";
import useStateCallback from "../../../util/customHooks/useStateCallback";


function PocketMoneyBalancesPage() {
    const {schoolList} = useContext(SchoolContext);
    const [query, setQuery] = useState("");
    const [school, setSchool] = useState("");
    const [group, setGroup] = useState("");
    const [balanceAmount, setBalanceAmount] = useState("");
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [loading3, setLoading3] = useState(false);
    const [overallPocketMoneyBalance, setOverallPocketMoneyBalance] = useState(false);
    const [schoolPocketMoneyBalances, setSchoolPocketMoneyBalances] = useState([]);
    const [first, setFirst] = useState("");
    const [meta, setMeta] = useState([]);
    const [pocketMoneyBalances, setPocketMoneyBalances] = useState([]);
    const [groupList, setGroupList] = useState(false);
    const [printableList, setPrintableList] = useState([]);
    const [modal, setModal] = useStateCallback(false);

    useEffect(() => {
        if (school) {
            getGroups(school);
        } else {
            setGroupList([]);
        }
    }, [school]);

  useEffect(() => {
      if (query || school || group || balanceAmount) {
          searchPocketMoneyBalances();
      } else {
          getPocketMoneyBalances(page);
      }
  }, [page]);

  useEffect(() => {
        getOverallPocketMoneyBalance();
}, [page]);

useEffect(() => {
    getSchoolPocketMoneyBalances();
}, []);

  const getOverallPocketMoneyBalance = async () => {
      const server_response = await ajaxBank.fetchOverallPocketMoneyBalance();
      if (server_response.status === "OK") {
        setOverallPocketMoneyBalance(server_response.details);
      } else {
        setOverallPocketMoneyBalance("404");
      }
    };
  
  const getPocketMoneyBalances = async (currentPage) => {
    setLoading(true);
    const server_response = await ajaxStudent.listAllPocketMoneyBalances(currentPage);
    setLoading(false);

    if (server_response.status === "OK") {
        setFirst(server_response.details.meta.offset);
        setMeta(server_response.details.meta.totalPages);
        setPocketMoneyBalances(server_response.details.data || []);
    } else {
        setPocketMoneyBalances([]);
    }
};

const searchPocketMoneyBalances = async (e) => {
    if (e) {
        e.preventDefault();
    }
    setLoading2(true);
    const server_response = await ajaxStudent.searchAllPocketMoneyBalances(page, school, query, group, balanceAmount);
    setLoading2(false);
    if (server_response.status === "OK") {
        setFirst(server_response.details.meta.offset);
        setMeta(server_response.details.meta.totalPages);
        setPocketMoneyBalances(server_response.details.data || []);
    } else {
        setPocketMoneyBalances([]);
    }
};



const getSchoolPocketMoneyBalances = async () => {
    setLoading3(true);
    const server_response = await ajaxBank.fetchAllSchoolPocketMoneyBalances();
    setLoading3(false);
    if (server_response.status === "OK") {
        setSchoolPocketMoneyBalances(server_response.details || []);  
    } else {
        setSchoolPocketMoneyBalances([]);
    }
};

    const getGroups = async (school) => {
        const server_response = await ajaxStudentGroup.fetchGroupList(school);
        if (server_response.status === "OK") {
            setGroupList(server_response.details);
        }
        else {
            setGroupList([]);
        }
    };

  const handlePagination = (newPage) => {
    if (newPage > 0 && newPage <= meta) {
      setPage(newPage);
    }
  };

  const setBalances = (e) => {
    e.preventDefault();
    setQuery("");
    setSchool("");
    setGroup("");
    setPage(1);
    setBalanceAmount("");
    getPocketMoneyBalances(1);
    
  };

  const exportToExcel = (data) => {
          const worksheetData = (data || []).map((item) => ({
            "Student Name": item.user,
            "Buzz Number": item.username,
            "School Name": item.school,
            "Class": item.group,
            "Pocket Money": item.balance.total_c,
           }));
        
          const worksheet = XLSX.utils.json_to_sheet(worksheetData);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Pocket Money Balances");
        
          XLSX.writeFile(workbook, "pocket_money_balances_list.xlsx");
    };

    const handleModal = () => {
    setModal(false, () =>
      setModal(
        <PrintFilterFormPM
          g={setPrintableList}
          h={exportToExcel}
          printableList={printableList}
          isOpen={true}
        />
      )
    );
  };


  return (
    <AppContainer title="Pocket Money Balances">
      <Toaster position="top-center" reverseOrder={false} />
        
       {modal}
        <div className="row">
            <div class="col-lg-12">
                <div class="card custom-card" style={{ paddingBottom: "10px" }}>
                    <div className="card-body map-card gradient-my-blue">
                        <div class="item-title mb-2" style={{ color: "white" }}>
                            <b>OVERALL</b>
                        </div>
                        <div class="row">
                        
                            <div class="col-xl-12 col-lg-12 col-sm-6 pr-0 pl-0">
                                <div class="text-center">
                                    <h2 class="mb-1 number-font" style={{ color: "white" }}>
                                        <span class="counter">
                                            UGX. {overallPocketMoneyBalance? overallPocketMoneyBalance:"..."}
                                        </span>
                                    </h2>
                                    <p class="mb-0 text-light"> Pocket Money Balance</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="row">
            <div className="col-lg-12 col-md-12 col-12 col-sm-12">
                <div className="row">
                <div className="col-lg-12 col-md-12 mt-3">
              <div className="card height-auto">
                <div className="card-body">
                <div class="heading-layout1 mg-b-5">
        <TableHeader
          title = "Pocket Money Balances List"
          subtitle="List of all the students with their pocket money balances sorted from highest to lowest"    
        />
        <div class="dropdown">
            
          {/* <a class="dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-expanded="false">...</a> */}
          <Link class="" onClick={setBalances} role="button"><i class="fas fa-redo-alt ml-3"></i></Link>
        <Link class="" onClick={handleModal} role="button"><i class="fas fa-file-excel ml-3"></i></Link>
          
        </div>
      </div>

      <form className="mg-t-20" onSubmit={searchPocketMoneyBalances}>
      <div className="row gutters-5">
        <div className="col-10-xxxl col-lg-10 col-12 form-group">
          <div className="row">
          <div className="col-lg-3 mt-2">
              <input
                type="text"
                placeholder="Enter first or last name..."
                style={{ border: "1px solid grey" }}
                value={query}
                onChange={(e)=>setQuery(e.target.value)}
                className="form-control"
              />
            </div>
            <div className="col-lg-3 mt-2">
              <Select
                onChange={(e) => setSchool(e ? e.school_id : "")}
                getOptionLabel={(option) => option.school_name}
                getOptionValue={(option) => option.school_id}
                isSearchable
                placeholder="Select school..."
                options={Array.isArray(schoolList) ? schoolList : []}
                value={
                  school === ""
                    ? null
                    : Array.isArray(schoolList) &&
                      schoolList.find((value) => value.school_id === school)
                }
              />
            </div>
            {school &&<div className="col-lg-3 mt-2">
              <Select
                      onChange={(e) => setGroup(e.group_id)}
                      getOptionLabel={(option) => option.group_name}
                      getOptionValue={(option) => option.group_id}
                      isSearchable
                      placeholder="Select class..."
                      options={Array.isArray(groupList) ? groupList : []}
                      value={
                        group === ""? null: Array.isArray(groupList) &&
                        groupList.find((value) => value.group_id === group)
                      }
                    />
            </div>}
            <div className="col-lg-3 mt-2">
              <select
                    style={{border: "1px solid grey"}}
                    className="col-12 form-control"
                    value={balanceAmount}
                    onChange={(e) => setBalanceAmount(e.target.value)}>
                    <option value="" selected disabled>PM balance range...</option>
                    <option value="0.1">0</option>
                    <option value="1000">1,000</option>
                    <option value="5000">5,000</option>
                    <option value="10000">10,000</option>
                    <option value="50000">50,000</option>
                    <option value="100000">100,000</option>
                    <option value="500000">500,000</option>

                </select>
            </div>
          </div>
        </div>

        <div className="col-2-xxxl col-lg-2 col-12 form-group">
          <button
            type="submit"
            className="btn-fill-lmd radius-30 text-light shadow-dodger-blue bg-dodger-blue ml-2"
          >
            SEARCH
          </button>
          
        </div>
      </div>
    </form>

      

      <div className="border-top mt-3"></div>
      <div className="table-responsive">
      {loading || loading2 ? (
        <Loader />
                      ) : (
        <table className="table display data-table text-nowrap">
            <thead>
                <tr>
                <th scope="col">No.</th>
                <th scope="col">Student Name</th>
                <th scope="col">Buzz Number</th>

                <th scope="col"> School</th>
                <th scope="col"> PM Balance</th>
                
                </tr>
            </thead>
            <tbody>
                {pocketMoneyBalances.length > 0 ? (
                    pocketMoneyBalances.map((item, index) => (
                    <tr key={index}>
                        

                        <td>{index + first + 1} </td>
                        
                        <td><OverlayTrigger placement="top" overlay={
                                                                <Tooltip id="refresh-tooltip">
                                                                    View Statement
                                                                </Tooltip>}><Link to={`/pocket-money-balances/statement/${item.user_id}?username=${encodeURIComponent(item.username)}&user=${encodeURIComponent(item.user)}&balance=${encodeURIComponent(item.balance.total_c)}`}>{item.user}
                                                                </Link></OverlayTrigger></td>
                        <td>{item.username}</td>

                        <td>{item.school}</td>
                        <td>UGX. {item.balance.total_c}</td>

                    </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan="5" style={{ textAlign: "center" }}>
                            No students registered yet.
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
      )}
        
      </div>
      <Pagination currentPage={page} totalPages={meta} onPageChange={handlePagination}/>
                </div>
              </div>
          </div>
                
                
                </div>
            </div>
            <div class="col-lg-12 col-md-12 col-12 col-sm-12">
                            <div className="row">
                            {loading3 ? (
                                <Loader />
                                  ):(
                                    schoolPocketMoneyBalances.map((item, index) => (
                                        <div key={index} class="col-lg-3 col-md-12 col-12 col-sm-12">
                                            <div class="card custom-card">
                                                <div class="card-body">
                                                    <div>
                                                        <h6>{item.school_name}</h6>
                                                        <h6><span class="fs-30 me-2" style={{fontSize:"20px"}}>UGX. {item.balance?item.balance.total_c:"..."}</span></h6>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </div>)))}
                                       
                                
                                
                            </div>
                        </div>
        </div>
        

        
      
    </AppContainer>
  );
}

export default PocketMoneyBalancesPage;
